import { PARAGRAPH_KEY, HEADING_KEY, LIST_ITEM_KEY } from '@techchange/pm-specs';

/**
 * Determines the alignments set on the selected node types.
 *
 * @param {Object} state  The current editor state.
 *
 * @returns {array} The list of active alignments, if any.
 */
const getActiveTextAlignment = (state) => {

	const { from, to } = state.selection;

	const paragraphNodeType = state.schema.nodes[PARAGRAPH_KEY];
	const headingNodeType = state.schema.nodes[HEADING_KEY];
	const listItemNodeType = state.schema.nodes[LIST_ITEM_KEY];

	const alignmentSet = [];

	// Filter out duplicates
	const alignmentHash = {};

	state.doc.nodesBetween(from, to, (node) => {

		if (node.type === paragraphNodeType ||
			node.type === headingNodeType ||
			node.type === listItemNodeType) {

			const alignmentKey = node.attrs && node.attrs.align;

			if (!alignmentHash[alignmentKey]) {

				alignmentSet.push(alignmentKey);
				alignmentHash[alignmentKey] = true;

			}

		}

		return true;

	});

	return alignmentSet;

};

export default getActiveTextAlignment;
